import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { Core, Decorative } from "@faire/design-tokens";
import { getSaleColorAndAssign } from "@faire/retailer-visitor-shared/components/getSaleColorAndAssign";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { getSettingAndAssignUpdateSaleColorCopy } from "@faire/retailer-visitor-shared/settings/getSettingUpdateSaleColorCopy";
import { MarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { EventsStore } from "@faire/retailer-visitor-shared/stores/domain/Events/shared/EventsStore";
import { getEventTheme } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { LineItemStyle } from "@faire/web-api--source/indigofair/data/LineItemStyle";
export var LineItemStyleSurface;
(function(LineItemStyleSurface) {
    LineItemStyleSurface["CHECKOUT_ORDER_SUMMARY"] = "CHECKOUT_ORDER_SUMMARY";
    LineItemStyleSurface["SINGLE_BRAND_ORDER"] = "SINGLE_BRAND_ORDER";
    LineItemStyleSurface["BRAND_CART_SUMMARY"] = "BRAND_CART_SUMMARY";
    LineItemStyleSurface["BRAND_CART_HEADER"] = "BRAND_CART_HEADER";
    LineItemStyleSurface["INVOICES"] = "INVOICES";
    LineItemStyleSurface["HAS_DISCOUNT"] = "HAS_DISCOUNT";
    LineItemStyleSurface["BRAND_ORDER_SUMMARY"] = "BRAND_ORDER_SUMMARY";
    LineItemStyleSurface["BRAND_LINE_ITEMS_WITH_DROPDOWN"] = "BRAND_LINE_ITEMS_WITH_DROPDOWN";
    LineItemStyleSurface["ORDER_SUMMARY_LINE_ITEM"] = "ORDER_SUMMARY_LINE_ITEM";
    LineItemStyleSurface["ORDER_SUMMARY"] = "ORDER_SUMMARY";
    LineItemStyleSurface["CART_TOTAL_SUMMARY"] = "CART_TOTAL_SUMMARY";
    LineItemStyleSurface["BRAND_ORDER_SUMMARY_NAME"] = "BRAND_ORDER_SUMMARY_NAME";
    LineItemStyleSurface["EDIT_BRAND_ORDER_SUMMARY"] = "EDIT_BRAND_ORDER_SUMMARY";
})(LineItemStyleSurface || (LineItemStyleSurface = {}));
var ClientLineItemStyle;
(function(ClientLineItemStyle) {
    ClientLineItemStyle["MARKET"] = "MARKET";
    ClientLineItemStyle["MARKET_NOT_LIVE"] = "MARKET_NOT_LIVE";
    ClientLineItemStyle["IS_MARKED_DOWN"] = "IS_MARKED_DOWN";
    ClientLineItemStyle["REFUND"] = "REFUND";
    ClientLineItemStyle["HAS_DISCOUNT"] = "HAS_DISCOUNT";
    ClientLineItemStyle["NO_DISCOUNT"] = "NO_DISCOUNT";
    ClientLineItemStyle["INVOICE"] = "INVOICE";
    ClientLineItemStyle["IS_DISCOUNT"] = "IS_DISCOUNT";
    ClientLineItemStyle["IS_DISCOUNT_AND_BRAND_PROMO"] = "IS_DISCOUNT_AND_BRAND_PROMO";
})(ClientLineItemStyle || (ClientLineItemStyle = {}));
var getMarketPromoTextColor = function() {
    var _getSaleColorAndAssign, _ref;
    return (_ref = (_getSaleColorAndAssign = getSaleColorAndAssign()) !== null && _getSaleColorAndAssign !== void 0 ? _getSaleColorAndAssign : getEventTheme("faireMarket").promoText) !== null && _ref !== void 0 ? _ref : getEventTheme("faireMarket").promoTextInverse;
};
export var ILineItemStyle = _object_spread({}, LineItemStyle, ClientLineItemStyle);
export var getLineItemColorByStyleAndSurface = function(style, surface) {
    switch(surface){
        case LineItemStyleSurface.BRAND_ORDER_SUMMARY_NAME:
            return getLineItemColorByBrandOrderSummaryName(style);
        case LineItemStyleSurface.ORDER_SUMMARY:
            return getLineItemColorByOrderSummary(style);
        case LineItemStyleSurface.CHECKOUT_ORDER_SUMMARY:
            return getCheckoutOrderSummarySurfaceColor();
        case LineItemStyleSurface.SINGLE_BRAND_ORDER:
            return getSingleBrandOrderSurfaceColor(style);
        case LineItemStyleSurface.BRAND_ORDER_SUMMARY:
            return getBrandOrderSummarySurfaceColor(style);
        case LineItemStyleSurface.ORDER_SUMMARY_LINE_ITEM:
            return getOrderSummaryLineItemColor(style);
        case LineItemStyleSurface.CART_TOTAL_SUMMARY:
            return getLineItemColorByCartTotalSummary(style);
        case LineItemStyleSurface.BRAND_CART_SUMMARY:
        case LineItemStyleSurface.INVOICES:
        case LineItemStyleSurface.EDIT_BRAND_ORDER_SUMMARY:
        default:
            return getLineItemColorBase(style);
    }
};
var getBrandOrderSummarySurfaceColor = function(style) {
    switch(style){
        case ILineItemStyle.FAIRE_PROMOTIONAL_EVENT_PROMO:
            return getMarketPromoTextColor();
        case ILineItemStyle.STRIKETHROUGH:
            return Core.text.disabled;
        case LineItemStyle.BRAND_PROMO:
            return getSaleColorAndAssign();
        case LineItemStyle.FAIRE_PROMO:
        case LineItemStyle.RETAILER_BRAND_LOYALTY_PROMO:
            return getSaleColorAndAssign();
        default:
            return getLineItemColorBase(style);
    }
};
var getCheckoutOrderSummarySurfaceColor = function() {
    return MarketStore.get().isLive ? getLineItemColorBase(EventsStore.get().eventLineItemStyle) : Core.surface.default;
};
var getOrderSummaryLineItemColor = function(style) {
    switch(style){
        case ILineItemStyle.FAIRE_PROMOTIONAL_EVENT_PROMO:
            return getMarketPromoTextColor();
        case LineItemStyle.BRAND_PROMO:
            return Decorative.shade.orange;
        default:
            return undefined;
    }
};
var getSingleBrandOrderSurfaceColor = function(style) {
    return style === LineItemStyle.BRAND_PROMO || style === LineItemStyle.FAIRE_PROMO || style === LineItemStyle.INSIDER_BENEFIT ? getLineItemColorBase(style) : undefined;
};
var getLineItemColorBase = function(style) {
    switch(style){
        case ILineItemStyle.MARKET:
            return getMarketPromoTextColor();
        case ILineItemStyle.INSIDER_BENEFIT:
            return Decorative.shade.teal;
        case ILineItemStyle.MARKET_NOT_LIVE:
        case ILineItemStyle.FREE_DUTIES:
        case ILineItemStyle.FAIRE_PROMO:
        case ILineItemStyle.HAS_DISCOUNT:
        case ILineItemStyle.BRAND_PROMO:
        case ILineItemStyle.R2M_CREDIT:
        case ILineItemStyle.ELEVATE_CREDIT:
        case ILineItemStyle.FAIRE_CREDIT:
            return getSaleColorAndAssign();
        case ILineItemStyle.IS_MARKED_DOWN:
            return Core.surface.subdued;
        case ILineItemStyle.FREE_SHIPPING:
            return getSettingAndAssignUpdateSaleColorCopy() ? Core.text.default : Decorative.shade.orange;
        case ILineItemStyle.STRIKETHROUGH:
            return Core.surface.disabled; // TODO replace with non-disabled color token
        case ILineItemStyle.REFUND:
            return Decorative.shade.yellow;
        case ILineItemStyle.NO_DISCOUNT:
        default:
            return Core.border.default;
    }
};
var getLineItemColorByOrderSummary = function(style) {
    switch(style){
        case ILineItemStyle.FAIRE_PROMOTIONAL_EVENT_PROMO:
            return getMarketPromoTextColor();
        case ILineItemStyle.BRAND_PROMO:
            return getSaleColorAndAssign();
        case ILineItemStyle.FAIRE_PROMO:
            return getSettingAndAssignUpdateSaleColorCopy() ? SERRANO : getLineItemColorBase(ILineItemStyle.MARKET_NOT_LIVE);
        case ILineItemStyle.RETAILER_BRAND_LOYALTY_PROMO:
            return getLineItemColorBase(ILineItemStyle.MARKET_NOT_LIVE);
        default:
            return getLineItemColorBase(style);
    }
};
var getLineItemColorByCartTotalSummary = function(style) {
    switch(style){
        case ILineItemStyle.FAIRE_PROMOTIONAL_EVENT_PROMO:
            return getMarketPromoTextColor();
        case LineItemStyle.BRAND_PROMO:
            return getSaleColorAndAssign();
        case LineItemStyle.INSIDER_BENEFIT:
            return Decorative.shade.teal;
        case ILineItemStyle.IS_DISCOUNT:
            return getSaleColorAndAssign();
        case ILineItemStyle.IS_DISCOUNT_AND_BRAND_PROMO:
            return getSaleColorAndAssign();
        default:
            return Core.border.default;
    }
};
var getLineItemColorByBrandOrderSummaryName = function(style) {
    switch(style){
        case ILineItemStyle.STRIKETHROUGH:
            return Core.border.default;
        default:
            return getBrandOrderSummarySurfaceColor(style);
    }
};
